/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import IScene from "../scene_interface";
import BoundingBox from "../bounding_box";
import IDocument from "./document_interface";
import IBoundingBox from "../bounding_box_interface";

export default
class Aggregation {

    private static UID: number = 1;
    private _sceneAPI: IScene;
    protected _sceneDocument: IDocument;
    private _UID: number;
    private _name: string;
    protected _objects: any;

    constructor(aSceneAPI: IScene, aSceneDocument: IDocument) {
        this._sceneAPI = aSceneAPI;
        this._sceneDocument = aSceneDocument;
        this._UID = Aggregation.UID++;
        this._name = "not named aggregation " + this._UID;
        this._objects = {};
    }

    public getUID(): number {
        return this._UID;
    }

    public setName(aName: string) {
        this._name = aName;
    }

    public getName(): string {
        return this._name;
    }

    public getSBoundingBox(): IBoundingBox {
        let aggregationSAPIBBox = new BoundingBox();

        for (let key in this._objects) {
            let object = this._objects[key];
            let objectSAPIBBox = object.getSBoundingBox();
            aggregationSAPIBBox.extend(objectSAPIBBox);
        }

        return aggregationSAPIBBox;
    }

    public getSBoundingBoxFromVisibleObjects(): IBoundingBox {
        let aggregationSAPIBBox = new BoundingBox();

        for (let key in this._objects) {
            let object = this._objects[key];
            let objectSAPIBBox = object.getSBoundingBoxFromVisibleObjects();
            aggregationSAPIBBox.extend(objectSAPIBBox);
        }

        return aggregationSAPIBBox;
    }

    /***
     * Create this aggregation active in the sceneAPI; in future, this behavior can change, but for e.g. set the views (lef, right, ...)
     * we need to somehow define what is the scene content (this will be defined by the application programmer aka module e.g. decision tree);
     * the aggregation can se set as active (e.g. when selected or for e.g. some modification dialogs etc.) so that we can e.g. get
     * bounding box for the aggregation or rotate, translate, scale the content related to some point etc.
     */
    public setActive() {
        this._sceneAPI.activityModule.setActiveObject(this);
    }

    public attachObject(aObject: any) {
        this._objects[aObject.getUID()] = aObject;
    }

    public detachObject(aObject: any) {
        let objectUID = aObject.getUID();
        if (this._objects[objectUID]) {
            delete this._objects[objectUID.getUID()];
        }
    }

    public select(aValue: boolean) {
        for (let key in this._objects) {
            let object = this._objects[key];
            object.select(aValue);
        }
    }

    public unselect() {
        this.select(false);
    }

    public applyManipulator() {
        for (let key in this._objects) {
            let object = this._objects[key];
            object.applyManipulator();
        }
    }

    public cancelManipulator() {
        for (let key in this._objects) {
            let object = this._objects[key];
            object.cancelManipulator();
        }
    }

    public show(aValue: boolean) {
        for (let key in this._objects) {
            let object = this._objects[key];
            object.show(aValue);
        }
    }

    public hide() {
        this.show(false);
    }

    public remove() {
        for (let key in this._objects) {
            let object = this._objects[key];
            object.detachFromAggregation();
        }
    }

    /*
    // TODO: this should be implemented in some derived class from this Aggregation e.g. ModelAggregation
    public removeWithContent()
    {
        for (let key in this._objects) {
            let object = this._objects[key];
            this._sceneDocument.removeModel(object);
        }
    }
    */
}